import React, { useState, useEffect } from 'react';
import Layout from '../../components/ui/Layout';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import SubHeader from '../../components/ui/SubHeader';
import ActionBoxes from '../../components/ui/ActionBoxes';
import OwnerCard from './components/OwnerCard';
import PropertyPortfolioCard from './components/PropertyPortfolioCard';
import OwnerProfilePanel from './components/OwnerProfilePanel';
import CommunicationPanel from './components/CommunicationPanel';
import DocumentLibrary from './components/DocumentLibrary';
import OwnerIntakeForm from './components/OwnerIntakeForm';
import RevenueTracker from './components/RevenueTracker';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

// Owner Management Modals
const AddOwnerModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#3B82F6',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">إضافة مالك جديد</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">اسم المالك</label>
              <input
                type="text"
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="أدخل الاسم الكامل"
                dir="rtl" />

            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-white font-semibold mb-2 block text-right">رقم الهوية</label>
                <input
                  type="text"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                  placeholder="رقم الهوية الوطنية"
                  dir="rtl" />

              </div>
              <div>
                <label className="text-white font-semibold mb-2 block text-right">رقم الهاتف</label>
                <input
                  type="tel"
                  className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                  placeholder="+962"
                  dir="rtl" />

              </div>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">البريد الإلكتروني</label>
              <input
                type="email"
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="example@email.com"
                dir="rtl" />

            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">رقم الحساب البنكي</label>
              <input
                type="text"
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="JO12 3456 7890 1234 5678 9012"
                dir="rtl" />

            </div>

            <button
              onClick={() => {
                console.log('Owner added');
                onClose();
              }}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
              <Icon name="UserPlus" size={18} color="#FFF" className="inline ml-2" />
              إضافة المالك
            </button>
          </div>
        </div>
      </div>
    </>);

};

const PortfolioModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#10B981',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">محفظة العقارات</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">إحصائيات المحفظة</h4>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-green-600/20 rounded-lg p-3">
                  <p className="text-green-400 text-sm">عقارات مؤجرة</p>
                  <p className="text-white text-2xl font-bold">24</p>
                </div>
                <div className="bg-yellow-600/20 rounded-lg p-3">
                  <p className="text-yellow-400 text-sm">عقارات شاغرة</p>
                  <p className="text-white text-2xl font-bold">6</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">الإيرادات الشهرية</h4>
              <p className="text-green-400 text-3xl font-bold text-right">45,600 دينار</p>
            </div>

            <button
              onClick={() => console.log('View full portfolio')}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transition-colors">
              <Icon name="Building2" size={18} color="#FFF" className="inline ml-2" />
              عرض المحفظة الكاملة
            </button>
          </div>
        </div>
      </div>
    </>);

};

const CommunicationModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#F59E0B',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">التواصل مع الملاك</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">اختر المالك</label>
              <select
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option>أحمد محمد العتيبي</option>
                <option>فاطمة عبدالله الشمري</option>
                <option>خالد سعد القحطاني</option>
              </select>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">نوع الرسالة</label>
              <select
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option>تحديث شهري</option>
                <option>طلب صيانة</option>
                <option>تحصيل إيجار</option>
                <option>تجديد عقد</option>
              </select>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">الرسالة</label>
              <textarea
                className="w-full h-28 bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="اكتب رسالتك هنا..."
                dir="rtl" />

            </div>

            <div className="flex gap-3">
              <button
                onClick={() => console.log('Send email')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors">
                <Icon name="Mail" size={18} color="#FFF" className="inline ml-2" />
                بريد
              </button>
              <button
                onClick={() => console.log('Send SMS')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transition-colors">
                <Icon name="MessageSquare" size={18} color="#FFF" className="inline ml-2" />
                رسالة
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

const DocumentsModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#EF4444',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">مستندات الملاك</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">المستندات المطلوبة</h4>
              <div className="space-y-2">
                {['نسخة الهوية الوطنية', 'سند الملكية', 'شهادة عدم ممانعة', 'عقد الوكالة']?.map((doc, idx) => (
                  <div key={idx} className="flex items-center justify-between p-3 bg-gray-700/30 rounded-lg">
                    <span className="text-white">{doc}</span>
                    <button className="px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded text-white text-sm transition-colors">
                      <Icon name="Upload" size={16} color="#FFF" className="inline ml-1" />
                      رفع
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={() => console.log('View all documents')}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-red-600 hover:bg-red-700 transition-colors">
              <Icon name="FileText" size={18} color="#FFF" className="inline ml-2" />
              عرض جميع المستندات
            </button>
          </div>
        </div>
      </div>
    </>);

};

const RevenueModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#8B5CF6',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">تتبع الإيرادات</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">الإيرادات الشهرية</h4>
              <div className="space-y-3">
                {[
                  { month: 'يناير 2026', amount: '42,500', status: 'مدفوع' },
                  { month: 'فبراير 2026', amount: '45,600', status: 'مدفوع' },
                  { month: 'مارس 2026', amount: '43,200', status: 'معلق' }
                ]?.map((item, idx) => (
                  <div key={idx} className="flex items-center justify-between p-3 bg-gray-700/30 rounded-lg">
                    <div className="text-right flex-1">
                      <p className="text-white font-medium">{item?.month}</p>
                      <p className="text-gray-400 text-sm">{item?.amount} دينار</p>
                    </div>
                    <span className={`px-3 py-1 rounded text-sm ${
                      item?.status === 'مدفوع' ? 'bg-green-600/20 text-green-400' : 'bg-yellow-600/20 text-yellow-400'
                    }`}>
                      {item?.status}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={() => console.log('Generate revenue report')}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors">
              <Icon name="DollarSign" size={18} color="#FFF" className="inline ml-2" />
              تقرير الإيرادات الكامل
            </button>
          </div>
        </div>
      </div>
    </>);

};

const ExportModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#06B6D4',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">تصدير قائمة الملاك</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">نوع التصدير</label>
              <select
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option>Excel (XLSX)</option>
                <option>PDF</option>
                <option>CSV</option>
              </select>
            </div>

            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">البيانات المضمنة</h4>
              <div className="space-y-2">
                {['المعلومات الشخصية', 'تفاصيل العقارات', 'الإيرادات', 'المستندات']?.map((item, idx) =>
                <label key={idx} className="flex items-center gap-3 cursor-pointer">
                    <input type="checkbox" defaultChecked className="w-5 h-5 rounded" />
                    <span className="text-gray-300 text-right flex-1">{item}</span>
                  </label>
                )}
              </div>
            </div>

            <button
              onClick={() => {
                console.log('Exporting owners list');
                alert('جاري تصدير قائمة الملاك...');
                onClose();
              }}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-cyan-600 hover:bg-cyan-700 transition-colors">
              <Icon name="Download" size={18} color="#FFF" className="inline ml-2" />
              تصدير الآن
            </button>
          </div>
        </div>
      </div>
    </>);

};

const BulkNotificationModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#EC4899',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">إشعار جماعي</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-white font-semibold mb-2 block text-right">المستلمون</label>
              <select
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option>جميع الملاك</option>
                <option>الملاك النشطون فقط</option>
                <option>ملاك محددون</option>
              </select>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">نوع الإشعار</label>
              <select
                className="w-full bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                dir="rtl">
                <option>تحديث عام</option>
                <option>تذكير بالصيانة</option>
                <option>تقرير شهري</option>
                <option>إشعار طارئ</option>
              </select>
            </div>

            <div>
              <label className="text-white font-semibold mb-2 block text-right">الرسالة</label>
              <textarea
                className="w-full h-28 bg-gray-800/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                placeholder="اكتب رسالتك هنا..."
                dir="rtl" />

            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  console.log('Sending bulk notification');
                  alert('تم إرسال الإشعار لجميع الملاك');
                  onClose();
                }}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-pink-600 hover:bg-pink-700 transition-colors">
                <Icon name="Bell" size={18} color="#FFF" className="inline ml-2" />
                إرسال الآن
              </button>
              <button
                onClick={() => console.log('Schedule notification')}
                className="flex-1 py-2.5 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors">
                <Icon name="Clock" size={18} color="#FFF" className="inline ml-2" />
                جدولة
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

const SettingsModal = ({ isOpen, onClose, actionColor }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto"
      style={{
        borderColor: actionColor || '#14B8A6',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }}>
        <div className="p-5" dir="rtl">
          <div className="flex items-center justify-between mb-5">
            <h3 className="text-xl font-bold text-white">إعدادات إدارة الملاك</h3>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">الإعدادات العامة</h4>
              <div className="space-y-3">
                <label className="flex items-center justify-between cursor-pointer">
                  <span className="text-gray-300">إشعارات تلقائية للملاك</span>
                  <input type="checkbox" defaultChecked className="w-5 h-5 rounded" />
                </label>
                <label className="flex items-center justify-between cursor-pointer">
                  <span className="text-gray-300">تقارير شهرية آلية</span>
                  <input type="checkbox" defaultChecked className="w-5 h-5 rounded" />
                </label>
                <label className="flex items-center justify-between cursor-pointer">
                  <span className="text-gray-300">تذكير بالصيانة الدورية</span>
                  <input type="checkbox" className="w-5 h-5 rounded" />
                </label>
              </div>
            </div>

            <div className="bg-gray-800/50 rounded-lg p-4">
              <h4 className="text-white font-semibold mb-3 text-right">نسبة العمولة</h4>
              <div className="flex items-center gap-3">
                <input
                  type="number"
                  defaultValue="5"
                  className="w-20 bg-gray-700/50 border border-gray-600 rounded-lg p-2 text-white text-center" />

                <span className="text-gray-300">%</span>
              </div>
            </div>

            <button
              onClick={() => {
                console.log('Settings saved');
                alert('تم حفظ الإعدادات بنجاح');
                onClose();
              }}
              className="w-full py-2.5 rounded-lg font-semibold text-white bg-teal-600 hover:bg-teal-700 transition-colors">
              <Icon name="Settings" size={18} color="#FFF" className="inline ml-2" />
              حفظ الإعدادات
            </button>
          </div>
        </div>
      </div>
    </>);

};

const OwnerPropertyManagement = () => {
  const navigate = useNavigate();
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showIntakeForm, setShowIntakeForm] = useState(false);
  const [editingOwner, setEditingOwner] = useState(null);
  const [activeTab, setActiveTab] = useState('portfolio');
  const [showQuickMenu, setShowQuickMenu] = useState(false);
  const [showNewContractModal, setShowNewContractModal] = useState(false);
  const [ownerContracts, setOwnerContracts] = useState([]);
  const [loadingContracts, setLoadingContracts] = useState(false);

  // Modal states for each action box
  const [showAddOwnerModal, setShowAddOwnerModal] = useState(false);
  const [showPortfolioModal, setShowPortfolioModal] = useState(false);
  const [showCommunicationModal, setShowCommunicationModal] = useState(false);
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const [showRevenueModal, setShowRevenueModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showBulkNotificationModal, setShowBulkNotificationModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  // Add this block - Define onQuickMenuToggle handler
  const handleQuickMenuToggle = () => {
    setShowQuickMenu(!showQuickMenu);
  };

  // Load owner contracts when owner is selected
  React.useEffect(() => {
    if (selectedOwner?.id) {
      loadOwnerContracts();
    }
  }, [selectedOwner]);

  const loadOwnerContracts = async () => {
    setLoadingContracts(true);
    try {
      const { data, error } = await supabase
        .from('contracts')
        .select(`
          id,
          contract_number,
          contract_type,
          status,
          amount,
          start_date,
          end_date,
          property:properties(
            title,
            property_type,
            address
          ),
          buyer_representation:buyer_representation_contracts(
            id,
            arddjo_retainer_percentage,
            client_retainer_percentage,
            arddjo_retainer_amount,
            client_retainer_amount,
            representation_duration_months,
            exclusive_representation,
            property_types,
            budget_min,
            budget_max,
            preferred_locations,
            arddjo_acceptance_status,
            client_acceptance_status
          )
        `)
        .eq('client_id', selectedOwner?.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      setOwnerContracts(data || []);
    } catch (error) {
      console.error('Error loading owner contracts:', error);
    } finally {
      setLoadingContracts(false);
    }
  };

  // Add this block - Define handler functions before they are used
  const handleExportOwners = () => {
    console.log('Exporting owners list');
    alert('جاري تصدير قائمة الملاك...');
  };

  const handleBulkNotification = () => {
    console.log('Sending bulk notification');
    alert('إرسال إشعار جماعي - قريباً');
  };

  const handleExportData = () => {
    console.log('Exporting owner data');
    alert('جاري تصدير البيانات...');
  };

  // Add this block - Define menuItems array
  const menuItems = [
  {
    path: '/property-management-dashboard',
    icon: 'Home',
    label: 'الرئيسية',
    color: 'from-blue-500 to-blue-600'
  },
  {
    path: '/owner-property-management',
    icon: 'UserCheck',
    label: 'إدارة الملاك',
    color: 'from-green-500 to-green-600'
  },
  {
    path: '/properties',
    icon: 'Building2',
    label: 'العقارات',
    color: 'from-purple-500 to-purple-600'
  },
  {
    path: '/tenants',
    icon: 'Users',
    label: 'المستأجرين',
    color: 'from-orange-500 to-orange-600'
  }];


  // Owner management action boxes with modal triggers
  const ownerActions = [
  {
    id: 'add-owner',
    icon: 'UserPlus',
    label: 'إضافة مالك',
    color: '#3B82F6',
    bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
    borderColor: 'rgba(59, 130, 246, 0.5)',
    onClick: () => setShowAddOwnerModal(true)
  },
  {
    id: 'portfolio',
    icon: 'Building2',
    label: 'محفظة العقارات',
    color: '#10B981',
    bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
    borderColor: 'rgba(16, 185, 129, 0.5)',
    onClick: () => setShowPortfolioModal(true)
  },
  {
    id: 'communication',
    icon: 'MessageSquare',
    label: 'التواصل',
    color: '#F59E0B',
    bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
    borderColor: 'rgba(245, 158, 11, 0.5)',
    onClick: () => setShowCommunicationModal(true)
  },
  {
    id: 'documents',
    icon: 'FileText',
    label: 'المستندات',
    color: '#EF4444',
    bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
    borderColor: 'rgba(239, 68, 68, 0.5)',
    onClick: () => setShowDocumentsModal(true)
  },
  {
    id: 'revenue',
    icon: 'DollarSign',
    label: 'تتبع الإيرادات',
    color: '#8B5CF6',
    bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
    borderColor: 'rgba(139, 92, 246, 0.5)',
    onClick: () => setShowRevenueModal(true)
  },
  {
    id: 'export',
    icon: 'Download',
    label: 'تصدير القائمة',
    color: '#06B6D4',
    bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
    borderColor: 'rgba(6, 182, 212, 0.5)',
    onClick: () => setShowExportModal(true)
  },
  {
    id: 'bulk-notify',
    icon: 'Bell',
    label: 'إشعار جماعي',
    color: '#EC4899',
    bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
    borderColor: 'rgba(236, 72, 153, 0.5)',
    onClick: () => setShowBulkNotificationModal(true)
  },
  {
    id: 'settings',
    icon: 'Settings',
    label: 'الإعدادات',
    color: '#14B8A6',
    bgGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.2) 0%, rgba(45, 212, 191, 0.25) 100%)',
    borderColor: 'rgba(20, 184, 166, 0.5)',
    onClick: () => setShowSettingsModal(true)
  }];



  const mockOwners = [
  {
    id: 1,
    name: 'أحمد محمد العتيبي',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16a507d98-1763294547027.png",
    avatarAlt: 'صورة شخصية لرجل أردني يرتدي بدلة رسمية في مكتب حديث',
    phone: '+962 79 123 4567',
    email: 'ahmed.alotaibi@email.com',
    nationalId: '9876543210',
    propertyCount: 3,
    status: 'نشط',
    verified: true,
    totalMonthlyRevenue: '1,820 دينار',
    bankAccount: 'JO12 3456 7890 1234 5678 9012',
    registrationDate: '15/03/2024'
  },
  {
    id: 2,
    name: 'فاطمة عبدالله الشمري',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_186cc5d24-1763296386782.png",
    avatarAlt: 'صورة شخصية لامرأة أردنية محجبة في بيئة مهنية',
    phone: '+962 78 234 5678',
    email: 'fatima.alshammari@email.com',
    nationalId: '8765432109',
    propertyCount: 5,
    status: 'نشط',
    verified: true,
    totalMonthlyRevenue: '3,250 دينار',
    bankAccount: 'JO23 4567 8901 2345 6789 0123',
    registrationDate: '22/01/2024'
  },
  {
    id: 3,
    name: 'خالد سعد القحطاني',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_176e4ce5b-1763295077832.png",
    avatarAlt: 'صورة شخصية لرجل أردني في الخمسينات يرتدي بدلة رسمية في مكتب فاخر',
    phone: '+962 77 345 6789',
    email: 'khaled.alqahtani@email.com',
    nationalId: '7654321098',
    propertyCount: 2,
    status: 'معلق',
    verified: false,
    totalMonthlyRevenue: '980 دينار',
    bankAccount: 'JO34 5678 9012 3456 7890 1234',
    registrationDate: '10/11/2023'
  },
  {
    id: 4,
    name: 'نورة إبراهيم الدوسري',
    avatar: "https://images.unsplash.com/photo-1612528390617-fa2f8b094c70",
    avatarAlt: 'صورة شخصية لامرأة أردنية شابة محجبة ترتدي ملابس عمل أنيقة في مكتب حديث',
    phone: '+962 79 456 7890',
    email: 'noura.aldosari@email.com',
    nationalId: '6543210987',
    propertyCount: 4,
    status: 'نشط',
    verified: true,
    totalMonthlyRevenue: '2,460 دينار',
    bankAccount: 'JO45 6789 0123 4567 8901 2345',
    registrationDate: '05/06/2024'
  },
  {
    id: 5,
    name: 'عبدالرحمن فهد المطيري',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_101f10bcb-1763296392759.png",
    avatarAlt: 'صورة شخصية لرجل أردني يرتدي بدلة رسمية في بيئة عمل تقليدية',
    phone: '+962 78 567 8901',
    email: 'abdulrahman.almutairi@email.com',
    nationalId: '5432109876',
    propertyCount: 1,
    status: 'غير نشط',
    verified: false,
    totalMonthlyRevenue: '0 دينار',
    bankAccount: 'JO56 7890 1234 5678 9012 3456',
    registrationDate: '18/09/2023'
  }];


  const mockProperties = [
  {
    id: 1,
    title: 'شقة فاخرة - عبدون',
    address: 'شارع الملك عبدالله الثاني، عبدون، عمان 11181',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12103aacf-1768163295114.png",
    imageAlt: 'شقة سكنية فاخرة بتصميم عصري مع أثاث راقي وإضاءة دافئة في عبدون بعمان',
    status: 'مؤجر',
    monthlyRevenue: '450 دينار',
    nextMaintenance: '15/02/2026'
  },
  {
    id: 2,
    title: 'فيلا عائلية - دير غبار',
    address: 'شارع الأمير شاكر بن زيد، دير غبار، عمان 11194',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18931a952-1768321989433.png",
    imageAlt: 'فيلا عائلية واسعة بتصميم معماري حديث مع حديقة خضراء وواجهة حجرية في دير غبار بعمان',
    status: 'مؤجر',
    monthlyRevenue: '800 دينار',
    nextMaintenance: '20/03/2026'
  },
  {
    id: 3,
    title: 'محل تجاري - وسط البلد',
    address: 'شارع الملك فيصل، وسط البلد، عمان 11118',
    image: "https://images.unsplash.com/photo-1565189440170-801fe35d7f5f",
    imageAlt: 'محل تجاري بواجهة زجاجية عصرية مع إضاءة LED وتصميم داخلي أنيق في وسط البلد بعمان',
    status: 'شاغر',
    monthlyRevenue: '0 دينار',
    nextMaintenance: '10/02/2026'
  }];


  const quickActions = [
  {
    label: 'إضافة مالك جديد',
    icon: 'UserPlus',
    onClick: () => {
      setEditingOwner(null);
      setShowIntakeForm(true);
    },
    roles: ['admin', 'property_manager'],
    variant: 'primary'
  },
  {
    label: 'تصدير قائمة الملاك',
    icon: 'Download',
    onClick: handleExportOwners,
    roles: ['admin', 'property_manager'],
    variant: 'default'
  },
  {
    label: 'إرسال إشعار جماعي',
    icon: 'Send',
    onClick: handleBulkNotification,
    roles: ['admin', 'property_manager'],
    variant: 'default'
  }];


  const statusOptions = [
  { value: '', label: 'جميع الحالات' },
  { value: 'نشط', label: 'نشط' },
  { value: 'معلق', label: 'معلق' },
  { value: 'غير نشط', label: 'غير نشط' }];


  const filteredOwners = mockOwners?.filter((owner) => {
    const matchesSearch =
    owner?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    owner?.phone?.includes(searchQuery) ||
    owner?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesStatus = !statusFilter || owner?.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const handleOwnerSelect = (owner) => {
    setSelectedOwner(owner);
    setActiveTab('portfolio');
  };

  const handleEditOwner = () => {
    setEditingOwner(selectedOwner);
    setShowIntakeForm(true);
  };

  const handleFormSubmit = async (formData) => {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) {
        alert('يجب تسجيل الدخول أولاً');
        return;
      }

      // Map form data to database schema
      const ownerData = {
        name: formData?.name,
        phone: formData?.phone,
        email: formData?.email,
        national_id: formData?.nationalId,
        bank_account: formData?.bankAccount,
        address: formData?.address,
        notes: formData?.notes
      };

      if (editingOwner) {
        // Update existing owner
        const { error } = await supabase
          ?.from('owners')
          ?.update(ownerData)
          ?.eq('id', editingOwner?.id)
          ?.eq('user_id', user?.id);

        if (error) throw error;
        alert('تم تحديث بيانات المالك بنجاح');
      } else {
        // Create new owner
        const { error } = await supabase
          ?.from('owners')
          ?.insert({
            ...ownerData,
            user_id: user?.id
          });

        if (error) throw error;
        alert('تم إضافة المالك بنجاح');
      }

      // Close modal and reload data
      setShowIntakeForm(false);
      setEditingOwner(null);
      
      // Reload owners list if you have a function for it
      // await loadOwners();
    } catch (error) {
      console.error('Error saving owner:', error);
      alert('فشل في حفظ بيانات المالك: ' + error?.message);
    }
  };

  const handlePropertyDetails = (property) => {
    console.log('View property details:', property);
  };

  const actionBoxesConfig = [
  {
    id: 'add-owner',
    icon: 'UserPlus',
    label: 'إضافة مالك',
    color: '#3B82F6',
    bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
    borderColor: 'rgba(59, 130, 246, 0.5)',
    onClick: () => console.log('Add Owner')
  },
  {
    id: 'excel-export',
    icon: 'FileSpreadsheet',
    label: 'تصدير Excel',
    color: '#10B981',
    bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
    borderColor: 'rgba(16, 185, 129, 0.5)',
    onClick: () => console.log('Export to Excel')
  },
  {
    id: 'revenue-report',
    icon: 'DollarSign',
    label: 'تقرير الإيرادات',
    color: '#F59E0B',
    bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
    borderColor: 'rgba(245, 158, 11, 0.5)',
    onClick: () => console.log('Revenue Report')
  }];


  return (
    <Layout onQuickMenuToggle={handleQuickMenuToggle}>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-4 md:p-6" dir="rtl">
        {/* Page Header */}
        <SubHeader pageTitle="إدارة الملاك والعقارات" />
        <div className="mb-6">
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">إدارة الملاك والعقارات</h1>
          <p className="text-gray-400">إدارة شاملة لملاك العقارات ومحافظهم الاستثمارية</p>
        </div>

        {/* Action Boxes */}
        <ActionBoxes
          actions={ownerActions}
          showNewContractModal={showNewContractModal}
          setShowNewContractModal={setShowNewContractModal}
          contractTypeConfig={{}} />


        {/* Search and Filter Bar */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <Input
              type="search"
              placeholder="بحث بالاسم، الهاتف، البريد..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)} />

            <Select
              placeholder="تصفية حسب الحالة"
              options={statusOptions}
              value={statusFilter}
              onChange={setStatusFilter} />
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="default"
              iconName="UserPlus"
              iconSize={18}
              onClick={() => {
                setEditingOwner(null);
                setShowIntakeForm(true);
              }}>

              <span className="hidden md:inline">إضافة مالك</span>
              <span className="md:hidden">إضافة</span>
            </Button>
            <Button
              variant="outline"
              size="icon"
              iconName="Download"
              iconSize={18}
              onClick={handleExportData} />

          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
          {/* Left Panel - Owner Directory */}
          <div className="lg:col-span-3 space-y-4">
            <div className="bg-black rounded-lg border border-primary/30 p-4">
              <div className="flex items-center justify-center gap-2 mb-4 px-4 py-3 rounded-xl border-2 shadow-warm-sm" style={{
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(251, 191, 36, 0.15) 100%)',
                borderColor: 'rgba(245, 158, 11, 0.4)'
              }}>
                <Icon name="Users" size={20} color="#F59E0B" />
                <h2 className="font-heading font-bold text-sm md:text-base" style={{
                  background: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  دليل الملاك
                </h2>
              </div>

              <div className="space-y-3 mb-4">
                <Input
                  type="search"
                  placeholder="بحث بالاسم، الهاتف، البريد..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)} />


                <Select
                  placeholder="تصفية حسب الحالة"
                  options={statusOptions}
                  value={statusFilter}
                  onChange={setStatusFilter} />

              </div>

              <div className="space-y-2 max-h-[600px] overflow-y-auto">
                {filteredOwners?.map((owner) =>
                <OwnerCard
                  key={owner?.id}
                  owner={owner}
                  onSelect={handleOwnerSelect}
                  isSelected={selectedOwner?.id === owner?.id} />

                )}
              </div>

              {filteredOwners?.length === 0 &&
              <div className="text-center py-8">
                  <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
                  <p className="text-muted-foreground mt-3 text-sm">
                    لا توجد نتائج
                  </p>
                </div>
              }
            </div>
          </div>

          {/* Center Panel - Owner Profile & Portfolio */}
          <div className="lg:col-span-6 space-y-4">
            <OwnerProfilePanel owner={selectedOwner} onEdit={handleEditOwner} />

            {selectedOwner &&
            <div className="bg-black rounded-lg border border-primary/30 overflow-hidden">
                <div className="border-b border-primary/30">
                  <div className="flex overflow-x-auto">
                    <button
                    onClick={() => setActiveTab('portfolio')}
                    className={`flex-shrink-0 px-4 md:px-6 py-3 text-sm md:text-base font-medium transition-colors ${
                    activeTab === 'portfolio' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
                    }>

                      محفظة العقارات
                    </button>
                    <button
                    onClick={() => setActiveTab('revenue')}
                    className={`flex-shrink-0 px-4 md:px-6 py-3 text-sm md:text-base font-medium transition-colors ${
                    activeTab === 'revenue' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
                    }>

                      تتبع الإيرادات
                    </button>
                    <button
                    onClick={() => setActiveTab('contracts')}
                    className={`flex-shrink-0 px-4 md:px-6 py-3 text-sm md:text-base font-medium transition-colors ${
                    activeTab === 'contracts' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
                    }>

                      عقود
                    </button>
                  </div>
                </div>

                <div className="p-4 md:p-6">
                  {activeTab === 'portfolio' &&
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {selectedOwner?.properties?.map((property) =>
                  <PropertyPortfolioCard
                    key={property?.id}
                    property={property}
                    onViewDetails={(prop) => console.log('View property details:', prop)} />

                  )}
                </div>
                }

                  {activeTab === 'revenue' &&
                <RevenueTracker owner={selectedOwner} />
                }

                  {activeTab === 'contracts' &&
                <div className="space-y-4">
                  {loadingContracts ?
                  <div className="flex items-center justify-center p-8">
                      <Icon name="Loader" size={32} className="animate-spin text-primary" />
                    </div> :
                  ownerContracts?.length > 0 ?
                  ownerContracts?.map((contract) =>
                  <div
                    key={contract?.id}
                    className="bg-card border border-border rounded-lg p-4 hover:shadow-warm transition-all">

                        <div className="flex items-start justify-between mb-3">
                          <div>
                            <h4 className="font-heading font-semibold text-foreground mb-1">
                              {contract?.contract_number}
                            </h4>
                            <p className="text-sm text-muted-foreground">
                              {contract?.contract_type === 'buyer_representation' ? 'عقد تمثيل مشتري' : contract?.contract_type}
                            </p>
                          </div>
                          <span className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success border border-success/20">
                            {contract?.status}
                          </span>
                        </div>

                        {contract?.buyer_representation?.[0] &&
                    <div className="bg-muted rounded-lg p-3 mb-3">
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <p className="text-xs text-muted-foreground mb-1">عمولة ARDDJO</p>
                                <p className="text-sm font-semibold text-primary">
                                  {contract?.buyer_representation?.[0]?.arddjo_retainer_percentage}% ({contract?.buyer_representation?.[0]?.arddjo_retainer_amount?.toLocaleString('ar-JO')} دينار)
                                </p>
                              </div>
                              <div>
                                <p className="text-xs text-muted-foreground mb-1">عمولة العميل</p>
                                <p className="text-sm font-semibold text-success">
                                  {contract?.buyer_representation?.[0]?.client_retainer_percentage}% ({contract?.buyer_representation?.[0]?.client_retainer_amount?.toLocaleString('ar-JO')} دينار)
                                </p>
                              </div>
                            </div>
                            <div className="mt-3 pt-3 border-t border-border">
                              <div className="flex items-center justify-between text-xs">
                                <span className="text-muted-foreground">ARDDJO:</span>
                                <span className={`px-2 py-1 rounded-full ${
                          contract?.buyer_representation?.[0]?.arddjo_acceptance_status === 'accepted' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`
                          }>
                                  {contract?.buyer_representation?.[0]?.arddjo_acceptance_status === 'accepted' ? 'موافق' : 'قيد الانتظار'}
                                </span>
                              </div>
                              <div className="flex items-center justify-between text-xs mt-2">
                                <span className="text-muted-foreground">العميل:</span>
                                <span className={`px-2 py-1 rounded-full ${
                          contract?.buyer_representation?.[0]?.client_acceptance_status === 'accepted' ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`
                          }>
                                  {contract?.buyer_representation?.[0]?.client_acceptance_status === 'accepted' ? 'موافق' : 'قيد الانتظار'}
                                </span>
                              </div>
                            </div>
                          </div>
                    }

                        <div className="flex items-center gap-4 text-xs text-muted-foreground">
                          <div className="flex items-center gap-1">
                            <Icon name="Calendar" size={12} />
                            <span>{new Date(contract?.start_date)?.toLocaleDateString('ar-JO')}</span>
                          </div>
                          <div className="flex items-center gap-1">
                            <Icon name="DollarSign" size={12} />
                            <span>{contract?.amount?.toLocaleString('ar-JO')} دينار</span>
                          </div>
                        </div>
                      </div>
                  ) :

                  <div className="text-center p-8 text-muted-foreground">
                      <Icon name="FileText" size={48} className="mx-auto mb-2 opacity-50" />
                      <p>لا توجد عقود لهذا المالك</p>
                    </div>
                  }
                </div>
                }
                </div>
              </div>
            }
          </div>

          {/* Right Panel - Communication & Documents */}
          <div className="lg:col-span-3 space-y-4">
            <CommunicationPanel owner={selectedOwner} />
            <DocumentLibrary owner={selectedOwner} />
          </div>
        </div>
      </div>

      {/* Owner Intake Form Modal */}
      {showIntakeForm &&
      <OwnerIntakeForm
        onClose={() => {
          setShowIntakeForm(false);
          setEditingOwner(null);
        }}
        onSubmit={handleFormSubmit}
        editData={editingOwner} />
      }

      {/* Action Box Modals */}
      <AddOwnerModal
        isOpen={showAddOwnerModal}
        onClose={() => setShowAddOwnerModal(false)}
        actionColor="#3B82F6" />

      <PortfolioModal
        isOpen={showPortfolioModal}
        onClose={() => setShowPortfolioModal(false)}
        actionColor="#10B981" />

      <CommunicationModal
        isOpen={showCommunicationModal}
        onClose={() => setShowCommunicationModal(false)}
        actionColor="#F59E0B" />

      <DocumentsModal
        isOpen={showDocumentsModal}
        onClose={() => setShowDocumentsModal(false)}
        actionColor="#EF4444" />

      <RevenueModal
        isOpen={showRevenueModal}
        onClose={() => setShowRevenueModal(false)}
        actionColor="#8B5CF6" />

      <ExportModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        actionColor="#06B6D4" />

      <BulkNotificationModal
        isOpen={showBulkNotificationModal}
        onClose={() => setShowBulkNotificationModal(false)}
        actionColor="#EC4899" />

      <SettingsModal
        isOpen={showSettingsModal}
        onClose={() => setShowSettingsModal(false)}
        actionColor="#14B8A6" />

    </Layout>);


};

export default OwnerPropertyManagement;